/* Popup Promo JS
 * - Shows popup after a delay (data-show-delay in seconds)
 * - Close via overlay, close button, or Esc
 * - Focus management (basic): move focus into dialog on open
 * - Thank-you mode: dispatch window event `popup:success` to switch content
 *   Example (after Klaviyo success): window.dispatchEvent(new CustomEvent('popup:success'));
 */

(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    var popups = document.querySelectorAll("[data-popup]");
    if (!popups.length) return;

    popups.forEach(function (el) {
      var delay = parseInt(el.getAttribute("data-show-delay") || "3", 10);
      var dialog = el.querySelector(".popup__dialog");
      var overlayBtn = el.querySelector("[data-popup-overlay]");
      var closeBtn = el.querySelector("[data-popup-close]");

      const checkCookie = (name) => {
        return document.cookie
          .split(";")
          .some((item) => item.trim().startsWith(name + "="));
      };

      const getCookie = (name) => {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      };

      const createCookie = (name, value, days) => {
        let expires = "";
        if (days) {
          const date = new Date();
          date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie =
          name +
          "=" +
          (value || "") +
          expires +
          "; path=/; secure; samesite=Lax";
      };

      function openPopup() {
        el.setAttribute("data-open", "true");
        el.setAttribute("aria-hidden", "false");
        if (dialog) dialog.focus();
        document.documentElement.style.overflow = "hidden";
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'ShDGX3']);
      }

      function closePopup() {
        el.removeAttribute("data-open");
        el.setAttribute("aria-hidden", "true");
        document.documentElement.style.overflow = "";
        if( checkCookie("klaviyo-closed") ){
          createCookie("klaviyo-closed", 2, 30);
        }else{
          createCookie("klaviyo-closed", 1, 30);
        }
      }

      // Timed open
      if (!(checkCookie("klaviyo-bg-email")) && Number(getCookie("klaviyo-closed")) != 2 ) {
        window.setTimeout(openPopup, Math.max(0, delay) * 1000);
      }

      // Close interactions
      if (overlayBtn) overlayBtn.addEventListener("click", closePopup);
      if (closeBtn) closeBtn.addEventListener("click", closePopup);
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") closePopup();
      });

      // Thank-you switch: listen for global event
      window.addEventListener("popup:success", function () {
        el.classList.add("popup--thanks");
        var title = el.querySelector("[data-popup-thanks-title]");
        var msg = el.querySelector("[data-popup-thanks-msg]");
        if (title) title.hidden = false;
        if (msg) msg.hidden = false;
          createCookie("klaviyo-bg-email", "true", 30);
      });

      // Optional: detect common Klaviyo success markers if present
      // If your Klaviyo embed adds a .klaviyo_styling .success or similar, you can hook it here.
      var formWrap = el.querySelector("[data-popup-form]");
      if (formWrap) {
        var observer = new MutationObserver(function (mList) {
          // Heuristic: look for nodes with text "Success" or aria-live status changes
          var successNode = formWrap.querySelector(
            '[aria-live="polite"], .klaviyo_messages, .success, [data-success="true"]'
          );
          if (
            successNode &&
            /success|thank/i.test(successNode.textContent || "")
          ) {
            window.dispatchEvent(new CustomEvent("popup:success"));
            observer.disconnect();
          }
        });
        observer.observe(formWrap, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      }
    });
  });
})();
